import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';
import { StringOptions } from '../utils/StringOptions';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { DataTools } from '../utils/DataTools';

export class StepWindow extends StepBase
{
    logicRef: LogicEngine | undefined;

    /** Add a window to the list of windows we're tracking in this holder */
    addWindow(step: PageStepType)
    {
        if (!this.logicRef)
            throw "Exception: should not happen but logicRef in StepWindow is null";

    }

    getWindowTitle(): string
    {
        return this.text;
    }

    isModal(): boolean
    {
        return this.hasOptions("modal");
    }

    getPage(): string
    {
        return this.option_1;
    }

    getSize(): StepWindow.Size
    {
        if (this.hasOptions("size"))
        {
            switch (DataTools.internalValidateString(this.options.checkOption("size").toLowerCase()))
            {
                case 'large':
                    return StepWindow.Size.Large;
                case 'full':
                    return StepWindow.Size.Full;
                case 'small':
                    return StepWindow.Size.Small;
                case 'medium':
                default:
                    return StepWindow.Size.Medium;
            }
        }
        return StepWindow.Size.Medium;
    }

    async processStep(logic: LogicEngine): Promise<boolean>
    {
        this.logicRef = logic;
        return super.processStep(logic);
    }
}

export namespace StepWindow
{
    export enum Size
    {
        Large = 'large',
        Medium = 'medium',
        Small = 'small',
        Full = 'full',
    };
};
